import { useContext } from "react";
import { Col, Row } from "reactstrap";
import HeaderLogo from "src/components/HeaderLogo";
import { translate } from "src/lib/i18n";

import { isNil } from "ramda";
import { Navigate } from "react-router-dom";
import { Footer } from "src/components/Footer";
import { ReceiptsContext } from "src/lib/receiptsContext";
import { ReceiptResult } from "./ReceiptsResult";

export const ReceiptsList = () => {
  const { receipts } = useContext(ReceiptsContext);

  if (isNil(receipts)) {
    return <Navigate to="/" />;
  }
  return (
    <Col
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "inherit",
        paddingBottom: "16px",
      }}
    >
      <HeaderLogo />
      <Row className="mx-2 text-center">
        <h2>
          <b>{translate("receiptsHome.receiptPortal")}</b>
        </h2>
      </Row>
      <Row className="mx-2 text-center overflow-auto justify-content-center">
        <ReceiptResult receipts={receipts} />
      </Row>
      <Footer />
    </Col>
  );
};
